import {AnnotationsReaderBase} from './AnnotationsReaderBase';

export class AnnotationsReaderIE extends AnnotationsReaderBase {
  _capture (svgData, meta) {
    // store info needed for rendering.
    this.svgData = svgData;

    // X and Y were scaled against the viewport during the drawing phase, but the CANVG SVG renderer doesn't know
    // that, so when it sees that the height and width of the SVG don't match the height and width we specify, it
    // scales position accordingly. We need to undo that. Width and height data come from the raw SVG, which has not
    // yet been scaled, so we scale it here.
    this._position = {
      x: meta.x / meta.scale,
      y: meta.y / meta.scale,
      w: meta.w * meta.scale,
      h: meta.h * meta.scale
    };
  }

  render (context) {
    context.drawSvg(this.svgData, -this._position.x, -this._position.y, this._position.w, this._position.h);
  }

  cleanup () {
    delete this.svgData;
    delete this.image;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/readers/AnnotationsReaderIE.js